import React, { useState, useEffect } from 'react';

const FolderView = (props) => {

    const [renderData, setRenderData] = useState(props.renderData)

    useEffect(() => {
        setTimeout(() => {
            feather.replace()
            $('[data-toggle="tooltip"]').tooltip();
        }, 2);
    }, [renderData])

    const handleSearch = (event) => {
        const target = event.target;
        if (target.value === '') {
            setRenderData(props.renderData);
        } else {
            const filteredList = props.renderData.filter(singleData => (
                singleData[props.mapping['name']].toLowerCase().startsWith(target.value.toLowerCase())
            ));
            setRenderData(filteredList);
        }
    }

    const handleSort = (type, event) => {
        event.preventDefault();
        const sortedArray = sortList(type, renderData);
        setRenderData(sortedArray);
    }

    const sortList = (type, array) => {
        const sortedData = JSON.parse(JSON.stringify(array));
        sortedData.sort((a, b) => {
            const nameA = a[props.mapping['name']].toLowerCase();
            const nameb = b[props.mapping['name']].toLowerCase();
            if (nameA < nameb) {
                return type === "ascending" ? -1 : 1;
            }
            if (nameA > nameb) {
                return type === "ascending" ? 1 : -1;
            }
            return 0
        });
        return sortedData;
    }

    let displayComponent = renderData.map((eachValue) => {
        let gridName = eachValue[props.mapping['name']].length > 20 ? `${eachValue[props.mapping['name']].substring(0, 20)}...` : eachValue[props.mapping['name']];

        return (
            <div className="col-sm-6 col-lg-4 col-xl-3 mg-t-10" id={`dashboard_${eachValue[props.mapping['id']]}`} key={eachValue[props.mapping['id']]} style={{ cursor: "pointer" }}>
                <div className="media media-folder">
                    <i className="feather" data-feather={props.mapping['icon'] ? props.mapping['icon'] : "fas fa-th-large desc-btn db-icon"}></i>
                    <div className="media-body" id={`dashboard_dataset_${eachValue[props.mapping['id']]}`}>
                        <h6><a className="link-02" data-toggle="tooltip" title={eachValue[props.mapping['name']]}>{gridName}</a></h6>
                        {eachValue[props.mapping['description']] ? <span>{eachValue[props.mapping['description']]}</span> : null}
                    </div>
                    <div className="dropdown-file">
                        <a href="" className="dropdown-link" data-toggle="dropdown"><i className="feather" data-feather="more-vertical"></i></a>
                        <div className="dropdown-menu dropdown-menu-right">
                            {
                                props.moreOptions.map(function (innerData) {
                                    let newLink = innerData.link ? innerData.link.replace("_replace_name_", eachValue[props.mapping['raw_name']]) : null
                                    return (
                                        <a className="dropdown-item details" id={innerData.id} href={innerData.type == "link" ? newLink : null} target={innerData.target ? innerData.target : null} data-toggle={innerData.type == "modal" ? "modal" : null} data-target={innerData.type == "link" ? newLink : null} onClick={innerData.type == "function" ? () => props.eventMore(innerData.id, eachValue) : null}>
                                            <i className="feather" data-feather={innerData.icon ? innerData.icon : "info"}></i>{innerData.name}
                                        </a>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    });

    return (
        <>
            <div className="d-sm-flex align-items-center justify-content-between">
                <div className="d-flex">
                    <div className="search-form">
                        <input type="search" className="form-control form-control-sm" placeholder="Search" defaultValue="" onChange={handleSearch} />
                        <button className="btn btn-white btn-sm" type="button"><i className="fa fa-search" aria-hidden="true"></i></button>
                    </div>
                    <div className="dropdown mg-l-10">
                        <button className="btn btn-white btn-sm  dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Sort
                    </button>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a className="dropdown-item" href="#" onClick={(event) => { handleSort('ascending', event) }}>Ascending</a>
                            <a className="dropdown-item" href="#" onClick={(event) => { handleSort('descending', event) }}>Descending</a>
                        </div>
                    </div>
                </div>
                <div className="d-none d-md-block">
                    <a className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" href="/admin/upload_data"><i className="feather" data-feather="list"></i></a>
                    <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" onClick={() => { props.eventMore("create", null) }}><i className="feather" data-feather="plus"></i></button>
                </div>
            </div>
            <div className="row">
                {displayComponent}
            </div>
        </>
    )
}

export default FolderView;
